import { render, staticRenderFns } from "./DeleteVekaletDialog.vue?vue&type=template&id=6ea483ee"
import script from "./DeleteVekaletDialog.vue?vue&type=script&lang=ts"
export * from "./DeleteVekaletDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports